import { render, staticRenderFns } from "./products_list.vue?vue&type=template&id=281bdf20&"
import script from "./products_list.vue?vue&type=script&lang=js&"
export * from "./products_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports